import { put, takeEvery, select, all } from 'redux-saga/effects'

import { Game, Api, Auth } from '../../../Core'
import Phase0Screen from './index'
import SkipTutorialConfirmationPopup from './SkipTutorialConfirmationPopup'

import * as actions from './phase0.actions'
import * as phasesActions from '../phases.actions'
import * as audioActions from '../../../Core/Game/AudioContainer/audio.actions'

function* init() {
  yield loadComponents()
}

/**
 * Load components.
 */
export function* loadComponents() {
  const components = {
    Phase0Screen,
    SkipTutorialConfirmationPopup,
  }

  yield put(Game.actions.registerComponents(components))
  yield put(audioActions.removeHowlAudio())
  yield put(audioActions.playHowlAudio(0))
}

export function* saveColonyName(action) {
  yield saveColonySettings(action)
  yield put(actions.saveColonyNameOk())
}

export function* saveColonyShield(action) {
  yield saveColonySettings(action)
  yield put(actions.saveColonyShieldOk())
  if (action.data.goToPhase) {
    yield put(phasesActions.goToPhase(1))
  }
}

export function* saveColonySettings(action) {
  const settings = action.data
  //Save the configuration into firebase
  const userInfo = yield select(Auth.selectors.getUserInfo)
  const payload = { ...settings, groupId: userInfo.licenseData.groupId }

  try {
    yield Api.put(`/colonySettings`, {}, payload)
  } catch (e) {
    console.log('Could not save the colony configuration', e)
    yield put(actions.saveColonySettingsError(e))
    if (e && e.status === 401) {
      console.log('Unauthorized')
      yield put(Game.actions.returnToPlatform())
    }
  }
}

export function* saveFederation(action) {
  yield saveSelectedFederation(action)
  yield put(actions.saveSelectedFederationOk())
  if (action.data.goToPhase) {
    yield put(phasesActions.goToPhase(1))
  }
}

export function* saveSelectedFederation(action) {
  const selectedFederation = action.data
  //Save the configuration into firebase
  const userInfo = yield select(Auth.selectors.getUserInfo)
  const payload = { selectedFederation, groupId: userInfo.licenseData.groupId }

  try {
    yield Api.put(`/federationSettings`, {}, payload)
  } catch (e) {
    console.log('Could not save the federation configuration', e)
    yield put(actions.saveSelectedFederationError(e))
    if (e && e.status === 401) {
      console.log('Unauthorized')
      yield put(Game.actions.returnToPlatform())
    }
  }
}

/**
 * Sagas entrypoint.
 */
export function* sagas() {
  yield all([
    init(),
    takeEvery(actions.SAVE_COLONY_NAME, saveColonyName),
    takeEvery(actions.SAVE_COLONY_SHIELD, saveColonyShield),
    takeEvery(actions.SAVE_FEDERATION, saveFederation),
  ])
}
